import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './styles/global.css'
import './styles/navbar.css'
import './styles/cover.css'
import './styles/toc.css'
import './styles/chapters.css'
import './styles/calculator.css'
import './styles/blocks.css'
import './styles/components.css'
import './styles/audio.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
